export default {"src":"/_next/static/media/Filter.b4fb7f6d.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};